import type { BulkTransactionRecord } from "../../api/transactions";

export type DashboardSummary = {
  pendingCount: number;
  executedCount: number;
  failedCount: number;
  successRecipientCount: string;
};

/**
 * Derive the dashboard's count cards from the bulk-transfer rows. Counts only —
 * no money arithmetic lives here. Money on the dashboard comes exclusively from
 * the authoritative server aggregate (`totalTransactionsAmountIdr`, a MoneyIdr
 * string), never a client-side reduce, which is what removes the RpNaN class of
 * bug.
 *
 * `failedCount` counts failed *bulk batches* (a row whose status is "Failed"),
 * not per-recipient failures — those live inside each batch's item list.
 */
export function summarizeDashboard(
  transactions: BulkTransactionRecord[],
): DashboardSummary {
  const executed = transactions.filter(
    (record) => record.status === "Executed",
  );

  return {
    pendingCount: transactions.filter((record) => record.status === "Pending")
      .length,
    executedCount: executed.length,
    failedCount: transactions.filter((record) => record.status === "Failed")
      .length,
    successRecipientCount: executed
      .reduce((sum, record) => sum + BigInt(record.totalRecipients), 0n)
      .toString(),
  };
}
